export default __webpack_public_path__ + "static/media/tenderlyLogoGrey.2ab3a792.svg";